import moment from "moment"
import React, { Component } from 'react';
import {observer} from "mobx-react"
import SortieStore from "../SortieStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import { DatePicker, KeyboardDatePicker,MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';

var _ = require('lodash');
import "moment/locale/fr";

moment.locale("fr");

@observer
export default class Gestion extends React.Component {
  constructor(props) {
    super(props);
    this.loadRecapitulatif = this.loadRecapitulatif.bind(this)
    this.updateMontant = this.updateMontant.bind(this)
    this.updateRemarque = this.updateRemarque.bind(this)
    this.updateDetails = this.updateDetails.bind(this)
    this.changeDate = this.changeDate.bind(this)
    this.updateDetails = _.debounce(this.updateDetails.bind(this), 500)
    this.state = {
      validated: false,
      recapitulatif: [],
      montant: 0,
      datepventree: new Date(),
      done: false
    };
     moment.locale("fr");
    this.loadRecapitulatif()
  }
  loadRecapitulatif(){
    axios.get("/api/v1/experts/app/sortie/recapitulatif?id="+SortieStore.rdv.id).then((data)=>{
      this.setState(data.data)
    })
  }
  validate(){
    axios.post("/api/v1/experts/app/sortie/valider",{id: SortieStore.rdv.id}).then((data)=>{
     location.reload()
    })
  }
  updateMontant(e){
    this.setState({montantFinal: e.target.value})
    this.updateDetails()
  }
  updateRemarque(e){
    this.setState({remarque: e.target.value})
    this.updateDetails()

  }
  updateDetails(){
    axios.post("/api/v1/experts/app/sortie/uploadRemarque",{
      remarque: this.state.remarque,
      montantFinal: this.state.montantFinal,
      datepventree: this.state.datepventree.utc(),
      id: SortieStore.rdv.id
    }).then((data)=>{
      console.log("detailles maj")
    })
  }
  changeDate(e){
    this.setState({
      datepventree: e
    })
    this.updateDetails()
  }
  componentDidMount(){
    SortieStore.showPDF = false
  }
  componentWillUnmount(){
    SortieStore.showPDF = true
  }
  render() {
    if(SortieStore.loaded){

      return(
        <div>
            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"fr"}>

            <div className="row">
              <div className="col s5">

                <h2 className="center">Récapitulatif</h2>
                <table>
                  <thead>
                    <tr>
                      <th>Piece</th>
                      <th>Titre</th>
                      <th>Quantite</th>
                      <th>prix unitaire</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.recapitulatif.map((piece,index)=>(
                      <React.Fragment key={index}>
                        <tr>
                          <th>{piece["piece"]}</th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        {piece["degats"].map((degat,ind)=>(
                          <tr key={ind}>
                            <td></td>
                            <td>{degat.title}</td>
                            <td>{degat.quantite}</td>
                            <td>{degat.amount/100.0} €</td>
                          </tr>
                          ))}
                      </React.Fragment>
                      ))}
                    <tr>
                      <th></th>
                      <th>total</th>
                      <th colSpan="2">{this.state.montant} €</th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col s7">
              <h1 className="center">Gestion de la sortie</h1>
              <div className="row">
                <div className="col s6">
                  <div className="input-field">
                    <input type="number" onChange={this.updateMontant} value={this.state.montantFinal}/>
                    <label className="active" htmlFor="number">
                    Montant final (0 => montant auto)
                    </label>
                  </div>
                </div>
                <div className="col s6">

                   <DatePicker
                    variant="inline"
                    label="Date baille entrée"
                    value={this.state.datepventree}
                    format="DD-MM-YYYY"
                    onChange={this.changeDate}
                    />
                </div>
                <div className="col s12">
                  <div className="input-field">
                    <label className="active" htmlFor="textarea">Commentaire libre</label>
                    <textarea onChange={this.updateRemarque} value={this.state.remarque} className="materialize-textarea" id="" cols="30" rows="10"></textarea>
                  </div>
                </div>
              </div>
              {this.state.done ? (
                  <div>
                    <h1>Données supplémentaires</h1>
                    <h1>Valider la sortie</h1>
                    <p>Si vous avez terminé l'état des lieux, et que les textes sont complets <br/>
                      Après validation l'état des lieux est envoyé à tout les partis
                    </p>
                    <p onClick={this.validate} className="center btn-large btn">Tout valider</p>

                  </div>
                ) : (
                  <div>
                    <p>Veuillez signer  la sortie avant de pouvoir la valider</p>
                  </div>
                )}
              </div>
            </div>
            </MuiPickersUtilsProvider>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}


